/* MAGIJOUETS – header scripts (sections/mj-header): 1. the logo on the night-violet bars, 2. the header itself (sticky
   height, menus, search and suggestions, cart count, phone menu).
   v17 (2026-10-10, speed): moved from the two inline <script> blocks of sections/mj-header.liquid, which now loads this
   file with defer where the second block was. The browser and Shopify's CDN keep it in cache, so it is no longer
   downloaded again inside every page. The few shop values (search and cart addresses, money format, menu labels) come
   from the header's JSON block; what the first screen needs before this file runs (logo already worked on in this
   visit, bar height, compact menu, shorter search placeholder) is done by two small inline scripts in the section.
   v17 home (2026-10-13): the computer menu is its own row after the bar (looked up in the section, not in <header>);
   one-button dropdowns (click, tap, keyboard; hover only for a mouse, by pointer type); is-stuck shadow from an
   IntersectionObserver sentinel; the inline search field of the bar gets the same suggestions; the phone menu
   closes in 220 ms (its slide is 200 ms). */
/* The logo on the night-violet bars. A logo file saved with an opaque white background (a Canva export, for
   example) would show as a white box: the white is taken out once in the browser (soft edges kept) and the result
   is reused for the visit. The empty margins around the drawing are cropped too (transparent or white), so the
   drawing itself fills the height set in the header settings. A transparent logo without margins is shown as it
   is. If the picture can't be read, it goes on a small white rounded badge. Header, phone menu and footer.
   Nothing changes on the store's files. */
(function () {
  var SEL = '.mj-logo__img, .mj-mm__logoimg, .mj-ft__logo img';
  function done(img, url, badge) {
    if (url) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = url; }
    if (badge) img.classList.add('is-badge');
    var ft = img.closest('.mj-ft__logo'); if (ft) ft.classList.toggle('is-clear', !badge);
    img.classList.add('is-ready');
  }
  var jobs = {};
  function key(src) { return 'mj-logo2:' + String(src).replace(/[?&](width|v)=\d+/g, ''); }
  // a 1000 px copy of the same file (Shopify's image server), so the cropped drawing stays sharp
  function big(src) {
    var u = String(src);
    if (u.indexOf('data:') === 0 || u.indexOf('/cdn/shop/') < 0 && u.indexOf('cdn.shopify.com') < 0) return u;
    return /[?&]width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=1000') : u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=1000';
  }
  // the box of the drawing: rows and columns holding a few visible pixels, plus a small margin
  function box(p, cw, ch) {
    var rows = new Uint32Array(ch), cols = new Uint32Array(cw), x, y, j;
    for (y = 0; y < ch; y++) for (x = 0; x < cw; x++) { j = (y * cw + x) * 4 + 3; if (p[j] > 24) { rows[y]++; cols[x]++; } }
    var mr = Math.max(1, Math.round(cw * .003)), mc = Math.max(1, Math.round(ch * .003)), t = 0, b = ch - 1, l = 0, r = cw - 1;
    while (t < ch && rows[t] < mr) t++;
    while (b > t && rows[b] < mr) b--;
    while (l < cw && cols[l] < mc) l++;
    while (r > l && cols[r] < mc) r--;
    if (t >= ch || l >= cw) return null;
    var pad = Math.round(Math.max(r - l, b - t) * .02);
    l = Math.max(0, l - pad); t = Math.max(0, t - pad); r = Math.min(cw - 1, r + pad); b = Math.min(ch - 1, b + pad);
    return { x: l, y: t, w: r - l + 1, h: b - t + 1 };
  }
  function work(img) {
    if (img.dataset.mjLogo) return; img.dataset.mjLogo = '1';
    var src = img.currentSrc || img.src; if (!src) { done(img); return; }
    var k = key(src), memo = null;
    try { memo = sessionStorage.getItem(k); } catch (e) {}
    if (memo === 'clear') { done(img); return; }
    if (memo === 'badge') { done(img, null, true); return; }
    if (memo && memo.indexOf('data:image/png') === 0) { done(img, memo); return; }
    // the header, phone menu and footer show the same file: it is worked on once and all three get the result
    if (jobs[k]) { jobs[k].push(img); return; }
    jobs[k] = [img];
    var all = function (url, badge) { var l = jobs[k] || [img]; delete jobs[k]; l.forEach(function (im) { if (!im.classList.contains('is-ready')) done(im, url, badge); }); };
    var t = new Image(), tried = false; t.crossOrigin = 'anonymous'; t.decoding = 'async';
    var safety = setTimeout(function () { all(null, true); }, 3500);
    t.onerror = function () { if (!tried && t.src !== src) { tried = true; t.src = src; return; } clearTimeout(safety); all(null, true); };
    t.onload = function () {
      clearTimeout(safety);
      try {
        var w = t.naturalWidth, h = t.naturalHeight; if (!w || !h) { all(); return; }
        var sc = Math.min(1, 1000 / w), cw = Math.max(1, Math.round(w * sc)), ch = Math.max(1, Math.round(h * sc));
        var c = document.createElement('canvas'); c.width = cw; c.height = ch;
        var x = c.getContext('2d'); x.drawImage(t, 0, 0, cw, ch);
        var d = x.getImageData(0, 0, cw, ch), p = d.data, n = cw * ch, i, j, m, a, op = 0, wh = 0;
        var corners = [0, cw - 1, (ch - 1) * cw, n - 1];
        for (i = 0; i < 4; i++) { j = corners[i] * 4; if (p[j + 3] > 200) { op++; if (Math.min(p[j], p[j + 1], p[j + 2]) >= 232) wh++; } }
        if (op >= 3 && wh < 3) { try { sessionStorage.setItem(k, 'badge'); } catch (e) {} all(null, true); return; }
        if (op >= 3) {
          for (i = 0; i < n; i++) {
            j = i * 4; m = Math.min(p[j], p[j + 1], p[j + 2]);
            if (m >= 246) { p[j + 3] = 0; continue; }
            if (m > 196) {
              a = (246 - m) / 50;
              p[j] = Math.max(0, Math.min(255, Math.round((p[j] - (1 - a) * 255) / a)));
              p[j + 1] = Math.max(0, Math.min(255, Math.round((p[j + 1] - (1 - a) * 255) / a)));
              p[j + 2] = Math.max(0, Math.min(255, Math.round((p[j + 2] - (1 - a) * 255) / a)));
              p[j + 3] = Math.round(p[j + 3] * a);
            }
          }
          x.putImageData(d, 0, 0);
        }
        var bx = box(p, cw, ch);
        // nothing to crop on a transparent logo: shown as it is
        if (op < 3 && (!bx || bx.w > cw * .96 && bx.h > ch * .96)) { try { sessionStorage.setItem(k, 'clear'); } catch (e) {} all(); return; }
        var out = c;
        if (bx && (bx.w < cw || bx.h < ch)) { out = document.createElement('canvas'); out.width = bx.w; out.height = bx.h; out.getContext('2d').drawImage(c, bx.x, bx.y, bx.w, bx.h, 0, 0, bx.w, bx.h); }
        var url = out.toDataURL('image/png');
        try { sessionStorage.setItem(k, url); } catch (e) {}
        all(url);
      } catch (e) { all(null, true); }
    };
    t.src = big(src);
  }
  function run() { document.querySelectorAll(SEL).forEach(work); }
  run();
  // v17: as a deferred file this runs once the page is parsed but before DOMContentLoaded: it still runs again then, as the inline script did
  if ((document.readyState === 'loading' || (document.readyState === 'interactive' && !(window.performance && performance.timing && performance.timing.domContentLoadedEventStart)))) document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', function () { document.querySelectorAll(SEL).forEach(function (i) { delete i.dataset.mjLogo; i.classList.remove('is-ready'); }); run(); });
})();

(function () {
/* The header can be set up again (theme editor: the section is re-rendered). Everything it adds outside its own
   section (the phone menu moved to <body>, page and window listeners, observers, timers) is removed by
   hdr.__mjStop(), called on shopify:section:unload or when a newer header starts. Settings are read from the
   header's data attributes, so a set-up started by shopify:section:load uses the new values. */
function init(hdr) {
  if (!hdr || hdr.__mjInit) return; hdr.__mjInit = true;
  var prev = window.__mjHdrLive;
  if (prev && prev !== hdr && prev.__mjStop) prev.__mjStop();
  window.__mjHdrLive = hdr;
  var sec = hdr.closest('.shopify-section, .mj-header-section') || document;
  var offs = [], dead = false, ro = null;
  function on(t, type, fn, opt) { t.addEventListener(type, fn, opt || false); offs.push(function () { t.removeEventListener(type, fn, opt || false); }); }
  var root = document.documentElement, body = document.body;
  var nav = sec.querySelector('[data-mj-nav]');
  var sticky = hdr.getAttribute('data-sticky') !== 'false', useModal = hdr.getAttribute('data-search-modal') === 'true', useDrawer = hdr.getAttribute('data-cart-drawer') !== 'false';
  var touchMQ = window.matchMedia('(hover: none) and (pointer: coarse)');

  /* ---------- height of the sticky bar: --header-height (body) and --mj-hdr (:root) ---------- */
  function setH() {
    var h = Math.round(hdr.getBoundingClientRect().height);
    body.style.setProperty('--header-height', h + 'px');
    root.style.setProperty('--mj-hdr', (sticky ? h : 0) + 'px');
  }
  setH();
  if ('ResizeObserver' in window) { ro = new ResizeObserver(setH); ro.observe(hdr); } else on(window, 'resize', setH);

  /* ---------- is-scrolled once the page scrolls (a hook); is-stuck once the header rows above the page (strip,
     computer menu row, phone search band) have gone under the bar: a soft shadow only (v17 home, 2026-10-13). A 1 px
     sentinel after those rows, shifted up by the bar's height (sections/mj-header, .mj-hdr-end), tells it. ---------- */
  var sc = false, openIt = null;
  function onScroll() {
    var on = window.scrollY > 4; if (on !== sc) { sc = on; hdr.classList.toggle('is-scrolled', on); }
    // an open panel of the computer menu row closes once that row has gone under the bar
    if (openIt && nav && nav.getBoundingClientRect().bottom <= hdr.getBoundingClientRect().bottom + 1) closeAll();
  }
  onScroll(); on(window, 'scroll', onScroll, { passive: true });
  var endEl = sec.querySelector('[data-mj-hdr-end]'), io = null;
  if (sticky && endEl && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (es) { var e = es[es.length - 1]; hdr.classList.toggle('is-stuck', !e.isIntersecting && e.boundingClientRect.top < 0); });
    io.observe(endEl);
  }

  /* ---------- compact layout when the menu doesn't fit on a computer ---------- */
  // the entries' own span (first to last) against the row's inner width: the hidden panels hanging out of the list
  // (absolutely placed) must not count, so scrollWidth is not used
  function fit() {
    if (!nav) return;
    hdr.classList.remove('is-tight');
    if (getComputedStyle(nav).display === 'none') return;
    var list = nav.firstElementChild; if (!list || !list.firstElementChild) return;
    var cs = getComputedStyle(nav), room = nav.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    if (list.lastElementChild.getBoundingClientRect().right - list.firstElementChild.getBoundingClientRect().left > room + 1) { hdr.classList.add('is-tight'); closeAll(); }
  }

  /* ---------- dropdowns and wide panels (computer menu row) ----------
     v17 home (2026-10-13): one button per entry (aria-expanded, aria-controls). Click, tap, Enter and Space toggle;
     ArrowDown / ArrowUp on the button open the panel and go to its first / last link; in the panel ArrowDown /
     ArrowUp move, Home / End jump, Escape closes and gives the focus back to the button; the focus leaving the entry,
     a click outside, another panel opening or the row scrolling away close it. A mouse (never touch or a pen) also
     opens it on hover after 120 ms and closes it 250 ms after leaving; a click on a panel the mouse opened keeps it
     open (it then stays until a click outside, Escape or the focus leaving). */
  var items = nav ? [].slice.call(nav.querySelectorAll('[data-mj-dd]')) : [];
  function btnOf(it) { return it.querySelector('[data-mj-dd-btn]'); }
  function panelOf(it) { return it.querySelector('[data-mj-dd-panel]'); }
  function place(it) {
    var p = panelOf(it); if (!p || p.classList.contains('mj-mega')) return;
    p.style.setProperty('--mj-dd-x', '0px');
    var r = p.getBoundingClientRect(), vw = document.documentElement.clientWidth, x = 0;
    if (r.right > vw - 12) x = vw - 12 - r.right;
    if (r.left + x < 12) x = 12 - r.left;
    p.style.setProperty('--mj-dd-x', Math.round(x) + 'px');
  }
  function open(it, by) {
    items.forEach(function (o) { if (o !== it) close(o); });
    clearTimeout(it.__mjT);
    if (it.classList.contains('is-open')) { if (by !== 'hover') it.__mjBy = by; return; }
    it.classList.add('is-open'); it.__mjBy = by; openIt = it;
    var b = btnOf(it); if (b) b.setAttribute('aria-expanded', 'true');
    place(it);
  }
  function close(it) {
    clearTimeout(it.__mjT);
    if (!it.classList.contains('is-open')) return;
    it.classList.remove('is-open'); it.__mjBy = '';
    if (openIt === it) openIt = null;
    var b = btnOf(it); if (b) b.setAttribute('aria-expanded', 'false');
  }
  function closeAll() { items.forEach(close); }
  function links(it) { var p = panelOf(it); return p ? [].slice.call(p.querySelectorAll('a[href]')) : []; }
  items.forEach(function (it) {
    var b = btnOf(it); if (!b) return;
    it.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse') return;
      clearTimeout(it.__mjT);
      if (it.classList.contains('is-open')) return;
      it.__mjT = setTimeout(function () { open(it, 'hover'); }, 120);
    });
    it.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse') return;
      clearTimeout(it.__mjT);
      if (!it.classList.contains('is-open') || it.__mjBy !== 'hover') return;
      it.__mjT = setTimeout(function () { close(it); }, 250);
    });
    b.addEventListener('click', function () {
      if (!it.classList.contains('is-open')) { open(it, 'click'); return; }
      // opened by the mouse a moment ago: the click keeps it open (it no longer closes when the pointer leaves)
      if (it.__mjBy === 'hover') { clearTimeout(it.__mjT); it.__mjBy = 'click'; return; }
      close(it);
    });
    it.addEventListener('keydown', function (e) {
      var ls = links(it), a = document.activeElement, i = ls.indexOf(a), k = e.key;
      if (k === 'Escape' || k === 'Esc') {
        if (!it.classList.contains('is-open')) return;
        e.preventDefault(); e.stopPropagation(); close(it); b.focus(); return;
      }
      if (!ls.length) return;
      if (a === b && (k === 'ArrowDown' || k === 'ArrowUp')) {
        e.preventDefault(); open(it, 'key'); ls[k === 'ArrowDown' ? 0 : ls.length - 1].focus(); return;
      }
      if (i < 0) return;
      if (k === 'ArrowDown') { e.preventDefault(); ls[(i + 1) % ls.length].focus(); }
      else if (k === 'ArrowUp') { e.preventDefault(); if (i === 0) b.focus(); else ls[i - 1].focus(); }
      else if (k === 'Home' || k === 'End') { e.preventDefault(); ls[k === 'Home' ? 0 : ls.length - 1].focus(); }
    });
    // the focus leaving the entry (Tab past the panel, a click elsewhere) closes its panel
    it.addEventListener('focusout', function (e) { var t = e.relatedTarget; if (t && !it.contains(t)) close(it); });
  });
  // left / right arrows move between the first-level entries
  if (nav) nav.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    var tops = [].slice.call(nav.querySelectorAll('.mj-nav__list > li > .mj-nav__link'));
    var cur = document.activeElement && document.activeElement.closest('.mj-nav__list > li'); if (!cur) return;
    var i = tops.indexOf(cur.querySelector('.mj-nav__link')); if (i < 0) return;
    var n = tops[(i + (e.key === 'ArrowRight' ? 1 : -1) + tops.length) % tops.length];
    e.preventDefault(); closeAll(); n.focus();
  });
  on(document, 'click', function (e) { if (!e.target.closest || !e.target.closest('[data-mj-dd]')) closeAll(); });
  // fix r1: the panels are now driven here; the CSS hover / focus-within fallback (sections/mj-header) stops
  if (nav) { nav.classList.add('is-ready'); offs.push(function () { nav.classList.remove('is-ready'); }); }
  on(document, 'keydown', function (e) { if (e.key === 'Escape' && openIt) { var it = openIt, b = btnOf(it); closeAll(); if (b && it.contains(document.activeElement)) b.focus(); } });

  /* ---------- search ---------- */
  var sBtn = hdr.querySelector('[data-mj-search-btn]'), sPanel = hdr.querySelector('[data-mj-spanel]'), phoneRow = sec.querySelector('[data-mj-hsearch]');
  function onScreen(el) { if (!el || !el.getClientRects().length) return false; var r = el.getBoundingClientRect(); return r.bottom > (hdr.getBoundingClientRect().bottom + 20) && r.top < window.innerHeight; }
  function openSearch() {
    closeAll(); sPanel.hidden = false; sPanel.classList.remove('is-in'); void sPanel.offsetWidth; sPanel.classList.add('is-in');
    sBtn.setAttribute('aria-expanded', 'true');
    var f = sPanel.querySelector('input[type="search"]'); if (f) { f.focus(); var v = f.value; f.value = ''; f.value = v; }
  }
  var sugClose = [];
  function closeSearch(back) { if (sPanel.hidden) return; sugClose.forEach(function (f) { f(); }); sPanel.hidden = true; sBtn.setAttribute('aria-expanded', 'false'); if (back) sBtn.focus(); }
  if (sBtn && sPanel) {
    sBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var modal = document.getElementById('search-modal');
      if (useModal && modal && typeof modal.showDialog === 'function') { modal.showDialog(); return; }
      // phones: the search field is already on screen under the bar
      var inRow = phoneRow && phoneRow.querySelector('input[type="search"]');
      if (inRow && onScreen(phoneRow)) { inRow.focus(); return; }
      if (sPanel.hidden) openSearch(); else closeSearch(true);
    });
    sBtn.addEventListener('keydown', function (e) { if (e.key === ' ') { e.preventDefault(); sBtn.click(); } });
    sPanel.querySelector('[data-mj-search-close]').addEventListener('click', function () { closeSearch(true); });
    sPanel.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.preventDefault(); closeSearch(true); } });
    on(document, 'click', function (e) { if (!sPanel.hidden && !sPanel.contains(e.target) && !sBtn.contains(e.target)) closeSearch(false); });
  }
  // a placeholder too long for a narrow field is shortened (never cut in the middle of a word)
  var phFull = hdr.getAttribute('data-ph') || 'Rechercher un jouet, un âge, une marque…', phShort = ['Rechercher un jouet, un âge…', 'Rechercher un jouet…', 'Rechercher…'];
  var phCv = document.createElement('canvas').getContext('2d');
  function fitPh() {
    sec.querySelectorAll('[data-mj-search-form] input[type="search"]').forEach(function (inp) {
      if (!inp.getClientRects().length) return;
      var cs = getComputedStyle(inp), room = inp.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight) - 4;
      phCv.font = '600 ' + cs.fontSize + ' ' + cs.fontFamily;
      var list = [phFull].concat(phShort), pick = list[list.length - 1];
      for (var i = 0; i < list.length; i++) if (phCv.measureText(list[i]).width <= room) { pick = list[i]; break; }
      if (inp.placeholder !== pick) inp.placeholder = pick;
    });
  }
  fitPh();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (!dead) fitPh(); });
  on(window, 'resize', fitPh);
  if (sBtn) sBtn.addEventListener('click', function () { requestAnimationFrame(fitPh); });

  // an empty search goes nowhere: the field is focused instead
  sec.querySelectorAll('[data-mj-search-form]').forEach(function (f) {
    f.addEventListener('submit', function (e) { var q = f.querySelector('input[name="q"]'); if (q && !q.value.trim()) { e.preventDefault(); q.focus(); } });
  });

  /* ---------- suggestions while typing (Shopify's /search/suggest.json) ----------
     An ARIA combobox: the focus stays in the field; ArrowDown / ArrowUp move the highlighted row
     (aria-activedescendant), Enter opens it (or searches when no row is highlighted), Escape closes the list (a
     second Escape closes the search bar). 200 ms after the last key; an older request is cancelled (AbortController).
     Up to 3 categories and 6 toys: photo, title and price only (never the brand), sold-out toys last; then
     "Voir tous les résultats pour « … »" (the form's own search, options[prefix]=last kept). Nothing found: a short
     note and the age chips. Everything is built as DOM nodes (no HTML from the answer is ever inserted). */
  // v17: the shop's values come from data- attributes of div[data-mj-hdr-cfg] (sections/mj-header), as the inline
  // script had them: theme asset files cannot hold Liquid
  var CFE = hdr.querySelector('[data-mj-hdr-cfg]'), cfg = function (n, d) { var v = CFE && CFE.getAttribute(n); return v === null || v === undefined || v === '' ? d : v; };
  var SUG = cfg('data-sug', '/search/suggest.json'), ROOT = cfg('data-root', '/'), MONEY = cfg('data-money', ''), CART_JS = cfg('data-cart', '/cart.js');
  var LBL = {}; try { LBL = JSON.parse(cfg('data-labels', '{}')) || {}; } catch (e) { LBL = {}; }
  var agesTpl = hdr.querySelector('template[data-mj-sug-ages]');
  var svgNS = 'http://www.w3.org/2000/svg';
  function moneyFmt() { var dflt = '{' + '{amount}' + '}', t = document.createElement('template'); t.innerHTML = String(MONEY || dflt); return (t.content.textContent || '').trim() || dflt; }
  var MF = moneyFmt();
  // Shopify's formats; like money_without_trailing_zeros, whole amounts have no decimals
  function money(c) {
    var m = MF.match(/\{\{\s*(\w+)\s*\}\}/), kind = m ? m[1] : 'amount', whole = c % 100 === 0;
    function d(prec, th, dec) { var p = (c / 100).toFixed(prec).split('.'); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (p[1] ? dec + p[1] : ''); }
    var v;
    switch (kind) {
      case 'amount_no_decimals': v = d(0, ',', '.'); break;
      case 'amount_with_comma_separator': v = d(whole ? 0 : 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = d(0, '.', ','); break;
      case 'amount_with_space_separator': v = d(whole ? 0 : 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': v = d(0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': v = d(whole ? 0 : 2, "'", '.'); break;
      case 'amount_with_period_and_space_separator': v = d(whole ? 0 : 2, ' ', '.'); break;
      default: v = d(whole ? 0 : 2, ',', '.');
    }
    return MF.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  // the JSON gives "219.00" (Shopify) or 21900 (cents, like /products/x.js)
  function cents(v) { if (v === null || v === undefined || v === '') return null; if (typeof v === 'number') return Math.round(v); var n = parseFloat(String(v).replace(/[^\d.\-]/g, '')); return isNaN(n) ? null : Math.round(n * 100); }
  function label(c) {
    var h = String(c.handle || '').toLowerCase(), t = String(c.title || '').trim();
    if (LBL.h && LBL.h[h]) return LBL.h[h];
    if (LBL.t && LBL.t[t.toLowerCase()]) return LBL.t[t.toLowerCase()];
    t = t.replace(/_/g, ', '); return t.charAt(0).toUpperCase() + t.slice(1);
  }
  function safeUrl(u, fb) { u = String(u || ''); return /^(\/(?!\/)|https?:\/\/)/i.test(u) ? u : fb; }
  function thumb(p) {
    var f = p.featured_image, u = (f && typeof f === 'object' ? f.url || f.src : f) || p.image || '';
    if (!u || typeof u !== 'string') return '';
    if (/cdn\.shopify\.com|\/cdn\/shop\//.test(u)) u += (u.indexOf('?') < 0 ? '?' : '&') + 'width=96';
    return u;
  }
  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt !== undefined) e.textContent = txt; return e; }
  function icon(d) { var s = document.createElementNS(svgNS, 'svg'); s.setAttribute('width', '18'); s.setAttribute('height', '18'); s.setAttribute('viewBox', '0 0 24 24'); s.setAttribute('fill', 'none'); s.setAttribute('stroke', 'currentColor'); s.setAttribute('stroke-width', '2.2'); s.setAttribute('stroke-linecap', 'round'); s.setAttribute('stroke-linejoin', 'round'); s.setAttribute('aria-hidden', 'true'); var p = document.createElementNS(svgNS, 'path'); p.setAttribute('d', d); s.appendChild(p); return s; }

  function suggest(form) {
    var inp = form.querySelector('input[name="q"]'), box = form.querySelector('[data-mj-sug]'), lb = box && box.querySelector('[data-mj-sug-lb]');
    if (!inp || !box || !lb) return;
    var none = box.querySelector('[data-mj-sug-none]'), live = form.querySelector('[data-mj-sug-live]'), row = form.closest('[data-mj-hsearch]');
    var tmr = null, ctl = null, cache = {}, opts = [], act = -1, shownQ = '', blurT = null;
    function say(t) { if (live && live.textContent !== t) live.textContent = t; }
    function mark() {
      opts.forEach(function (o, i) { o.setAttribute('aria-selected', i === act ? 'true' : 'false'); });
      if (act >= 0 && opts[act]) { inp.setAttribute('aria-activedescendant', opts[act].id); opts[act].scrollIntoView({ block: 'nearest' }); }
      else inp.removeAttribute('aria-activedescendant');
    }
    function fit() {
      if (box.hidden) return;
      var vv = window.visualViewport, h = vv ? vv.height + vv.offsetTop : window.innerHeight, top = box.getBoundingClientRect().top;
      box.style.maxHeight = Math.max(180, Math.min(560, Math.round(h - top - 12))) + 'px';
    }
    function hide() {
      clearTimeout(tmr); if (ctl) { ctl.abort(); ctl = null; }
      if (box.hidden && inp.getAttribute('aria-expanded') === 'false') return;
      box.hidden = true; inp.setAttribute('aria-expanded', 'false'); act = -1; mark();
      if (row) row.classList.remove('is-sug');
    }
    function open(hasOpts) {
      box.hidden = false; inp.setAttribute('aria-expanded', hasOpts ? 'true' : 'false');
      if (row) row.classList.add('is-sug');
      fit();
    }
    function option(id, href, cls) { var a = el('a', 'mj-sug__o' + (cls ? ' ' + cls : '')); a.id = id; a.href = href; a.setAttribute('role', 'option'); a.setAttribute('aria-selected', 'false'); a.tabIndex = -1; return a; }
    function show(q, data) {
      var r = (data && data.resources && data.resources.results) || {}, ps = (r.products || []).slice(0, 6), cs = (r.collections || []).slice(0, 3);
      lb.textContent = ''; opts = []; act = -1; shownQ = q; mark();
      var pre = box.id + '-o';
      if (!ps.length && !cs.length) {
        none.textContent = '';
        var p = el('p'); p.appendChild(document.createTextNode('Aucun jouet trouvé pour « ')); p.appendChild(el('b', '', q)); p.appendChild(document.createTextNode(' ». Essayez un autre mot, ou choisissez un âge :'));
        none.appendChild(p);
        if (agesTpl) { var ag = el('div', 'mj-sug__ages'); ag.appendChild(agesTpl.content.cloneNode(true)); none.appendChild(ag); }
        else p.lastChild.textContent = ' ». Essayez un autre mot.';
        none.hidden = false; lb.hidden = true; open(false);
        say('Aucun jouet trouvé pour « ' + q + ' ».');
        return;
      }
      none.hidden = true; lb.hidden = false;
      function group(name, items, make) {
        var g = el('div', 'mj-sug__g'); g.setAttribute('role', 'group'); g.setAttribute('aria-label', name);
        var h = el('div', 'mj-sug__h', name); h.setAttribute('aria-hidden', 'true'); g.appendChild(h);
        items.forEach(function (it) { var o = make(it, pre + opts.length); if (o) { g.appendChild(o); opts.push(o); } });
        lb.appendChild(g);
      }
      if (cs.length) group('Catégories', cs, function (c, id) {
        var href = safeUrl(c.url, ROOT + 'collections/' + encodeURIComponent(c.handle || ''));
        var a = option(id, href);
        a.appendChild(icon('M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z'));
        a.appendChild(el('span', '', label(c)));
        return a;
      });
      if (ps.length) group('Jouets', ps, function (pr, id) {
        var href = safeUrl(pr.url, ROOT + 'products/' + encodeURIComponent(pr.handle || ''));
        var a = option(id, href, 'mj-sug__o--p');
        var ph = el('span', 'mj-sug__ph'), src = thumb(pr);
        if (src) { var im = el('img'); im.src = src; im.alt = ''; im.width = 48; im.height = 48; im.loading = 'lazy'; im.decoding = 'async'; ph.appendChild(im); }
        a.appendChild(ph);
        var t = el('span', 'mj-sug__t'); t.appendChild(el('b', '', String(pr.title || '')));
        var lo = cents(pr.price_min !== undefined ? pr.price_min : pr.price), hi = cents(pr.price_max), pv = cents(pr.price);
        if (lo === null) lo = pv;
        if (lo !== null) t.appendChild(el('span', '', (hi !== null && hi > lo ? 'Dès ' : '') + money(lo)));
        if (pr.available === false) t.appendChild(el('small', '', 'Épuisé'));
        a.appendChild(t);
        return a;
      });
      var all = option(pre + 'all', form.getAttribute('action') + '?' + new URLSearchParams(new FormData(form)).toString(), 'mj-sug__all');
      all.appendChild(el('span', '', 'Voir tous les résultats pour « ' + q + ' »'));
      all.appendChild(icon('M5 12h14M13 6l6 6-6 6'));
      lb.appendChild(all); opts.push(all);
      open(true);
      var n = ps.length + cs.length;
      say(n + ' suggestion' + (n > 1 ? 's' : '') + ' pour « ' + q + ' ».');
    }
    function load(q) {
      if (cache[q]) { show(q, cache[q]); return; }
      if (ctl) ctl.abort(); ctl = window.AbortController ? new AbortController() : null;
      var u = new URLSearchParams();
      u.set('q', q); u.set('resources[type]', 'product,collection'); u.set('resources[limit]', '6'); u.set('resources[limit_scope]', 'each');
      u.set('resources[options][unavailable_products]', 'last'); u.set('resources[options][fields]', 'title,product_type,variants.title');
      var mine = ctl;
      fetch(SUG + '?' + u.toString(), { headers: { Accept: 'application/json' }, credentials: 'same-origin', signal: mine ? mine.signal : undefined })
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
        .then(function (d) {
          cache[q] = d; if (ctl === mine) ctl = null;
          // only for what is still typed, while the field (or its list) has the focus
          if (inp.value.trim() === q && form.contains(document.activeElement)) show(q, d);
        })
        .catch(function (e) { if (e && e.name === 'AbortError') return; if (ctl === mine) ctl = null; hide(); });
    }
    inp.addEventListener('input', function () {
      var q = inp.value.trim(); clearTimeout(tmr);
      if (q.length < 2) { hide(); say(''); return; }
      if (q !== shownQ) { act = -1; mark(); }
      tmr = setTimeout(function () { load(q); }, 200);
    });
    inp.addEventListener('focus', function () { var q = inp.value.trim(); if (q.length >= 2 && cache[q]) show(q, cache[q]); });
    inp.addEventListener('keydown', function (e) {
      var k = e.key, isOpen = !box.hidden;
      if (k === 'ArrowDown' || k === 'ArrowUp') {
        if (!isOpen) { var q = inp.value.trim(); if (q.length >= 2) { e.preventDefault(); clearTimeout(tmr); load(q); } return; }
        if (!opts.length) return;
        e.preventDefault();
        if (k === 'ArrowDown') act = act >= opts.length - 1 ? 0 : act + 1;
        else act = act === 0 ? -1 : act < 0 ? opts.length - 1 : act - 1;
        mark();
      } else if (k === 'Enter') {
        if (isOpen && act >= 0 && opts[act]) { e.preventDefault(); opts[act].click(); }
      } else if (k === 'Escape') {
        if (isOpen) { e.preventDefault(); e.stopPropagation(); hide(); }
      } else if (k === 'Tab') hide();
    });
    // a click on a row keeps the focus in the field (the row is a normal link: the click opens it)
    box.addEventListener('mousedown', function (e) { if (e.target.closest('[role="option"]')) e.preventDefault(); });
    form.addEventListener('focusout', function () { clearTimeout(blurT); blurT = setTimeout(function () { if (!form.contains(document.activeElement)) hide(); }, 150); });
    on(document, 'click', function (e) { if (!box.hidden && !form.contains(e.target)) hide(); });
    on(window, 'resize', fit);
    if (window.visualViewport) on(window.visualViewport, 'resize', fit);
    on(window, 'scroll', function () { if (!box.hidden) fit(); }, { passive: true });
    sugClose.push(hide);
  }
  sec.querySelectorAll('[data-mj-search-form]').forEach(suggest);

  /* ---------- cart: Horizon's cart drawer when the theme has one, live count ---------- */
  var cartLink = hdr.querySelector('[data-mj-cart-link]');
  if (cartLink && useDrawer) cartLink.addEventListener('click', function (e) {
    var d = document.querySelector('cart-drawer-component');
    if (!d || e.metaKey || e.ctrlKey || e.shiftKey) return;
    try {
      if (typeof d.open === 'function') { e.preventDefault(); d.open(); }
      else if (typeof d.showDialog === 'function') { e.preventDefault(); d.showDialog(); }
    } catch (err) { location.href = cartLink.href; }
  });
  function paint(n) {
    document.querySelectorAll('[data-mj-cart-count]').forEach(function (b) {
      b.textContent = n; b.setAttribute('data-empty', n > 0 ? 'false' : 'true');
    });
    if (cartLink) cartLink.setAttribute('aria-label', 'Panier, ' + n + ' article' + (n > 1 ? 's' : ''));
  }
  var rT = null;
  function refresh() {
    clearTimeout(rT);
    rT = setTimeout(function () {
      fetch(CART_JS, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); }).then(function (c) { paint(c.item_count || 0); }).catch(function () {});
    }, 150);
  }
  ['cart:update', 'cart:updated', 'cart:refresh', 'cart:change'].forEach(function (name) {
    on(document, name, function (e) {
      var c = e.detail && e.detail.resource;
      if (c && typeof c.item_count === 'number' && Array.isArray(c.items)) paint(c.item_count);
      refresh();
    });
  });
  on(window, 'pageshow', function (e) { if (e.persisted) refresh(); });

  /* ---------- phone menu (snippets/mj-menu) ---------- */
  var mm = sec.querySelector('[data-mj-mm]') || document.getElementById('mj-mm'), mmBtn = hdr.querySelector('[data-mj-mm-open]'), mmT = null, lastFocus = null;
  if (mm && mmBtn) {
    // one phone menu only: a copy left in <body> by an earlier header goes away
    [].forEach.call(document.querySelectorAll('[data-mj-mm]'), function (x) { if (x !== mm) x.remove(); });
    if (mm.parentElement !== body) body.appendChild(mm);
    var panel = mm.querySelector('[data-mj-mm-panel]');
    var focusables = function () {
      return [].slice.call(panel.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), summary, [tabindex]:not([tabindex="-1"])'))
        .filter(function (el) { return el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden'; });
    };
    var openMM = function () {
      clearTimeout(mmT); closeAll(); if (sPanel) closeSearch(false);
      lastFocus = document.activeElement;
      var sbw = window.innerWidth - root.clientWidth;
      if (sbw > 0) body.style.setProperty('padding-right', sbw + 'px');
      mm.hidden = false; root.classList.add('mj-lock');
      mmBtn.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(function () { requestAnimationFrame(function () { mm.classList.add('is-open'); }); });
      setTimeout(function () { var x = mm.querySelector('[data-mj-mm-close].mj-mm__x'); if (x) x.focus({ preventScroll: true }); }, 40);
    };
    var closeMM = function (noFocus) {
      if (mm.hidden) return;
      mm.classList.remove('is-open'); root.classList.remove('mj-lock'); body.style.removeProperty('padding-right');
      mmBtn.setAttribute('aria-expanded', 'false');
      mmT = setTimeout(function () { mm.hidden = true; }, 220);
      if (!noFocus) (mmBtn.getClientRects().length ? mmBtn : (lastFocus || mmBtn)).focus({ preventScroll: true });
    };
    window.mjMenu = { open: openMM, close: closeMM, hdr: hdr };
    mmBtn.addEventListener('click', openMM);
    mm.querySelectorAll('[data-mj-mm-close]').forEach(function (el) { el.addEventListener('click', function () { closeMM(); }); });
    mm.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); closeMM(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
    });
    // focus that escapes the open menu (e.g. a screen reader) is brought back
    on(document, 'focusin', function (e) { if (!mm.hidden && mm.classList.contains('is-open') && !mm.contains(e.target)) { var f = focusables(); if (f.length) f[0].focus(); } });
    // the computer layout came back (window made wider): the menu closes
    on(window, 'resize', function () { if (!mm.hidden && !mmBtn.getClientRects().length) closeMM(true); });
    // a link to the page itself (anchor) closes the menu
    mm.addEventListener('click', function (e) { var a = e.target.closest && e.target.closest('a[href]'); if (a && a.hash && a.pathname === location.pathname) closeMM(true); });
  }

  fit();
  on(window, 'resize', function () { fit(); setH(); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (!dead) { fit(); setH(); } });

  hdr.__mjStop = function () {
    if (dead) return; dead = true;
    offs.forEach(function (f) { f(); }); offs = [];
    if (ro) ro.disconnect();
    if (io) io.disconnect();
    items.forEach(function (it) { clearTimeout(it.__mjT); });
    clearTimeout(rT); clearTimeout(mmT);
    if (mm) {
      if (mm.classList.contains('is-open') || !mm.hidden) { root.classList.remove('mj-lock'); body.style.removeProperty('padding-right'); }
      if (mm.parentElement === body) mm.remove();
    }
    if (window.mjMenu && window.mjMenu.hdr === hdr) window.mjMenu = null;
    if (window.__mjHdrLive === hdr) window.__mjHdrLive = null;
  };
}

window.mjHeaderInit = init;
init(document.querySelector('[data-mj-header]'));
if (!window.__mjHdrHooks) {
  window.__mjHdrHooks = true;
  // the editor fires these on the section element, with its id in detail.sectionId
  var find = function (e) {
    var id = e.detail && e.detail.sectionId, t = e.target, h = null;
    if (id) h = document.querySelector('[data-mj-header][data-section="' + (window.CSS && CSS.escape ? CSS.escape(id) : id) + '"]');
    if (!h && t && t !== document && t.querySelector) h = t.querySelector('[data-mj-header]');
    return h;
  };
  document.addEventListener('shopify:section:unload', function (e) { var h = find(e); if (h && h.__mjStop) h.__mjStop(); });
  document.addEventListener('shopify:section:load', function (e) { var h = find(e); if (h && window.mjHeaderInit) window.mjHeaderInit(h); });
}
})();
